import {
  ArrayPath,
  FieldArray,
  useFieldArray,
  UseFormReturn,
} from "react-hook-form";
import { z } from "zod";
import { TripFormSchema } from "../../Types/Trip";
import PointsSelector from "./PointsSelector";
import RouteTripMap from "./SelectPointMap";

export default function RoutePlanner({
  form,
  defaultFieldObject,
}: {
  form: UseFormReturn<z.infer<typeof TripFormSchema>>;
  defaultFieldObject: FieldArray<
    z.infer<typeof TripFormSchema>,
    ArrayPath<z.infer<typeof TripFormSchema>>
  >;
}) {
  const { fields, append, remove, swap, update } = useFieldArray<
    z.infer<typeof TripFormSchema>
  >({
    control: form.control,
    name: "points",
  });
  return (
    <>
      <PointsSelector<z.infer<typeof TripFormSchema>>
        defaultFieldObject={defaultFieldObject}
        form={form}
        append={append}
        fields={fields}
        remove={remove}
        swap={swap}
        update={update}
      />
      <div className="flex justify-center">
        <RouteTripMap
          originalCoordsArray={fields.map((f, i) => ({
            title: f.title,
            address: f.address,
            lat: f.lat,
            lon: f.lon,
            index: i,
          }))}
        />
      </div>
    </>
  );
}
